import './App.css';
import "./navbar.css";
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './navbar';
import Home from './home.js';
import QuickView from './quickview.js';
import Footer from './footer.js';
import Report from "./report.js";
import axios from 'axios';
import ReportData from "./reportdata.js";
import AllData from './data.js';
import Login from './login.js';
import { useEffect, useState } from 'react';
import RegisterEmp from './registeremployee.js';
import RegisterPatient from './register.js';
import Dynamic from './dynamicpage.js';
import BalanceData from './balanceSheet.js';
import BookAppoint from './book.js';
import { ClipLoader } from 'react-spinners';
import Contact from './contact.js';
import Aboutus from './about.js';
import { useMediaQuery } from 'react-responsive';
import Navigation from "./navigationpanel.js"
import { useNavigate } from 'react-router-dom';
import AlreadyLogged from './alreadlogged.js';
import { dataesalab } from './constants.js';

function App() {
  return (
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  );
}


function Main() {
  const rootUrl = "http://localhost:3000";
  const localrootUrl = "https://ahkserver.onrender.com";
  const [res, setRes] = useState();
  const [auth, setAuth] = useState(true);
  const [quickview,setQuickviw] = useState(false);
  const [book,setbook]=useState([]);
  const [index,setIndex] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataposter = await axios.get(`${localrootUrl}/getsession`, { withCredentials: true });
        const response = dataposter.data;
        setRes(response);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [location]);

  useEffect(() => {
    if (res && res.isAuth) {
      setAuth(res.isAuth);
    } else {
      setAuth(false); // Optional: Set auth to false if res or res.isAuth is falsy
    }
  }, [res]);

  useEffect(()=>{
    if(location.pathname=="/logout"){
      const logoutuser = async ()=>{
        const logout = await axios.post(`${localrootUrl}/logout`,null,{withCredentials:true});
        const response = logout.data;
        if(response){
            if(response.success){
                setAuth(false);
                navigate("/login");
            }else{
                setAuth(true);
            }
        }
      }
      logoutuser();
    }
  },[location])

  // useEffect(()=>{
  //   setbook((prev)=>[...prev,])
  // },[])

  return (
    <>
      {quickview?null:res?res.role=="admin"?<Navbar key={auth} admin={true} authenticated={auth}/>:<Navbar key={auth} admin={false} authenticated={auth}/>:<Navbar key={auth} admin={false} authenticated={auth}/>}
      {quickview?null:auth?isMobile?null:res?res.role=="admin"?<Navigation admin={true}/>:<Navigation admin={false}/>:null:null}
      <QuickView setBook={(val)=>{setbook([...book,val])}} bookdata={book} setInd={(string)=>string=="prev"&&index>0?setIndex(index-1):string=="next"&&index<dataesalab.length?setIndex(index+1):null} index={index} view={quickview} setView={(val)=>setQuickviw(val)}/>
      <Routes>
        <Route path='/' element={<Home setInd={(val)=>setIndex(val)} setQuick={(val)=>setQuickviw(val)}/>} />
        <Route path='/reports' element={<Report />} />
        <Route path='/login' element={auth?<AlreadyLogged/>:<Login/>} /> 
        <Route path='/uploadReports' element={auth?<ReportData />:<Login/>}/>
        <Route path='/registerPatient' element={auth?<RegisterPatient/>:<Login/>}/>
        <Route path='/book' element={<BookAppoint testtoadd={book}/>}/>
        <Route path='/seeAll' element={auth?<AllData/>:<Login/>} />
        <Route path='/:test' element={<Dynamic setBook={(stringval)=>setbook((prev)=>[...prev,stringval])} bookdata={book}/>} />
        <Route path='/checkBalance' element={auth?res?res.role=="admin"?<BalanceData/>:<Login/>:<Login/>:<Login/>} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/logout' element={<ClipLoader size={150} className='loader' loading={auth}/>}/>
        <Route path='/about' element={<Aboutus/>}/>
        <Route path='/registerEmp' element={auth?res?res.role=="admin"?<RegisterEmp/>:<Login/>:<Login/>:<Login/>}/> 
      </Routes>
      {quickview?null:<Footer />}
    </>
  );
}

export default App;